import { environment } from 'src/environments/environment';

const STORAGE_KEY = 'h2s_dev_api_override';
const PROD_URLS = {
  apiUrl: 'https://h2s-api.hoptoschool.com',
  centrifugoUrl: 'wss://h2s-api.hoptoschool.com/connection/websocket',
};

/**
 * Debug-only override for which backend a dev build talks to. `environment`
 * is a plain mutable object (only the binding is `const`), so mutating its
 * properties here — before bootstrapApplication() constructs any service —
 * propagates to every file that reads `environment.apiUrl` directly, with
 * no need to route all of them through a shared service.
 *
 * No-ops entirely in production builds/native apps. Call once, at the top
 * of main.ts, before bootstrapApplication().
 */
export function applyDevApiOverride(): void {
  if (environment.production) return;
  if (isUsingProdInDev()) {
    environment.apiUrl = PROD_URLS.apiUrl;
    environment.centrifugoUrl = PROD_URLS.centrifugoUrl;
  }
}

export function isUsingProdInDev(): boolean {
  return localStorage.getItem(STORAGE_KEY) === 'prod';
}

/** Flip the override and reload — apiUrl is only read once at bootstrap. */
export function setUseProdInDev(useProd: boolean): void {
  if (useProd) localStorage.setItem(STORAGE_KEY, 'prod');
  else localStorage.removeItem(STORAGE_KEY);
  window.location.reload();
}
